import logo from './logo.svg';
import './App.css';
import Hero from './components/Hero';
import VideoSection from './components/VideoSection';

function App() {
  return (
    <div>
      <Hero/>
      <VideoSection/>
    </div>
  );
}

export default App;
